
export class OcorRemidoWebModel {

    constructor(
        public sqocorrencia?: string,
        public dsocorrencia?: string,
        public vlocorrencia?: number,
        public vlSaldo?: number,
        public dtReferencia?: string,
        public tpOcorrencia?: number,
        public irDebitoCredito?: string
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/orco-remido-web.model.ts